import React from 'react';
import { Typography } from 'antd';
import { WarehouseLiquidCard } from '../../api/warehouse';
import CardSection from './CardSection';

const { Text } = Typography;

interface OneCLinksSectionProps {
  card?: WarehouseLiquidCard;
  items?: { item_id: string; item_name: string | null }[];
  catalogId?: number;
}

const OneCLinksSection: React.FC<OneCLinksSectionProps> = ({ card, items, catalogId }) => {
  const links = card?.onec_items || items || [];
  const linkedCatalogId = card?.catalog_id || catalogId;

  return (
    <CardSection title="Связь с 1С" defaultOpen={false}>
      <div style={{ fontSize: 13 }}>
        {links.map(it => (
          <div key={it.item_id} style={{ marginBottom: 8 }}>
            <div>{it.item_name || '—'}</div>
            <Text type="secondary" style={{ fontSize: 12 }}>GUID: </Text>
            <Text copyable style={{ fontSize: 12 }}>{it.item_id}</Text>
          </div>
        ))}
        {linkedCatalogId && (
          <div style={{ marginTop: 8 }}>
            <Text type="secondary">Каталог: </Text>#{linkedCatalogId}
          </div>
        )}
      </div>
    </CardSection>
  );
};

export default OneCLinksSection;
